export const TYPE_DANGER = 'danger';
export const TYPE_SUGGESTION = 'suggestion';
export const TYPE_SUGGESTION_DARK = 'suggestion-dark';
export const TYPE_WARNING = 'warning';
export const TYPE_WARNING_SOFT = 'warning-soft';
export const TYPE_SUCCESS = 'success';
export const TYPE_MAINTENANCE = 'maintenance';
export const TYPE_SOLUTION = 'solution';
